export default Object.freeze({
  'bonbonniere-tulum': {
    name: 'Bonbonniere',
    caption: 'Follow The Red Light',
    logo:
      'https://imgix.cosmicjs.com/ddc833b0-1568-11ec-9133-6f7b9313cf59-bonbonniere.png?h=200&w=200',
    smallLogo:
      'https://imgix.cosmicjs.com/16114590-d4d4-11ee-9ce5-59949019255e-logo-bonbonniere-tulum.png',
    secondaryColor: '#817d7d',
    color: '#4a1f1f',
    video: {
      title: '🧨 Red Nights ',
      youtube: 'true',
      content:
        '<strong>Step into the Luxurious Rhythm</strong>: Where Nightlife Dreams Come Alive. Experience the epitome of elegance and dance to the beats of the extraordinary intense caribbean nights at <strong>Bonbonniere Tulum.</strong>',
      id: 'nQfJfuTvww0',
      videoUrl: 'https://www.youtube.com/embed/nQfJfuTvww0',
    },
  },
  'mia-beach-club-tulum': {
    name: 'Mia Tulum',
    caption: 'Restaurant & Beach Club',
    logo:
      'https://imgix.cosmicjs.com/988e3350-d4d6-11ee-9ce5-59949019255e-logo-mia-beach-club-tulum.png',
    color: '#f95959',
    secondaryColor:  '#f6acac',
    video: {
      title: 'MIA - ✅ Must Go If ',
      content:
        '<p>- You seek a techno-house party with a vibrant atmosphere .  Mia Tulum has a great selection and variety of djs. <br><strong>NO DRESS CODE !</strong></p>',
      youtube: false,
      poster:
        'https://imgix.cosmicjs.com/073b52b0-483c-11ee-89ab-17371fc03105-image.png',
      videoUrl:
        'https://imgix.cosmicjs.com/f9b8f660-24f5-11ee-982a-ed7f706ddfc5-Mia-Tulum-video-night.MP4',
    },
  },
  'bagatelle-tulum': {
    name: 'Bagatelle Tulum',
    caption: 'Living The French Joy de vivre',
    logo:
      'https://imgix.cosmicjs.com/3c946670-d5a6-11ee-9ce5-59949019255e-logo-bagatelle-tulum.png',
    color: 'rgb(172 145 126)',
    secondaryColor: '#bc9999',
    articles: ['bagatelle-tulum-dinner-party'],
    video: {
      title: '🏆 PRO TIP',
      poster:
        'https://imgix.cosmicjs.com/d6d7ab40-483c-11ee-89ab-17371fc03105-image.png',
      youtube: false,
      caption: 'ARODES - Red District Nights',
      content:
        '<strong>Bagatelle\'s</strong> central location in the beach zone not only makes it <strong>the perfect spot for a festive dinner</strong>, but also provides easy access to other popular venues such as <a href="/tulum-clubs/bonbonniere-tulum">Bonbonniere</a>, <a href="/tulum-clubs/vagalume-tulum">Vagalume</a>, and  <a href="/tulum-clubs/mia-beach-club-tulum">Mia</a>, allowing you to continue the party at your next chosen destination in just a breeze.',
      videoUrl:
        'https://imgix.cosmicjs.com/1bb8f9b0-2684-11ee-b83c-8d84c532f1e4-Bagatelle-Tulum-Club-Video-mp4.MP4',
    },
  },
  'vagalume-tulum': {
    name: 'Vagalume',
    caption: 'Beach Club & Night Club',
    color: '#8f684d',
    secondaryColor: '#292016',
    logo:
      'https://imgix.cosmicjs.com/55d7ade0-07d5-11ed-b7be-d956591ad437-vagalume-logo.png?h=60',
    video: {
      title: '📺 IN ACTION: Summerians',
      youtube: 'true',
      content: '<hr> <p> <strong>Vagalume</strong> offers a collection of 💥 explosive <strong>show brands</strong> known for their <strong>high-quality production</strong> and unmistakable Ibiza influence. Each show at Vagalume possesses its own distinct vibe. From the energetic <strong> Sinner sessions</strong>,  to the mesmerizing <strong>Summerians.</strong> ',
      id: 'x1ePVYFl08I?t=390',
      videoUrl: 'https://www.youtube.com/embed/x1ePVYFl08I?t=390',
    },
  },
  'confessions-tulum': {
    name: 'Confessions',
    caption: 'After Dinner & Nightclub',
    color: '#704acf',
    secondaryColor: '#c351c8',
    logo:
      'https://imgix.cosmicjs.com/eae741c0-d4d9-11ee-9ce5-59949019255e-logo-confessions-tulum.png',
    video: {
      title: '🌴 AFTER-DINNER PARTY',
      content:
        'Feel alive through the <strong>neon lights of this exotic jungle bar and lounge</strong>. Unveil the Exotic Vibes at Confessions Tulum.',
      poster:
        'https://imgix.cosmicjs.com/9fd31d10-f0c1-11ec-8fb8-5d396858ac9b-Picture2.jpg',
      youtube: false,
      videoUrl:
        'https://imgix.cosmicjs.com/d48ee460-eb78-11ec-bb77-f7704be6fe97-WhatsApp-Video-2022-06-13-at-12.22.16-PM.mp4',
    },
  },
  'papaya-playa': {
    name: 'Papaya Playa',
    caption: 'Legendary Saturday Nights',
    color: 'rgb(115 66 82)',
    secondaryColor: '#313742',
    logo:
      'https://imgix.cosmicjs.com/a8886e20-d4d5-11ee-9ce5-59949019255e-logo-papaya-playa.png',
    video: {
      title: 'BLOND:ISH LIVE SET: 2023',
      youtube: true,
      content:
        '<strong>Papaya Playa Project is a one-stop destination for music lovers</strong>, a unique blend of hotel, restaurant, and beach club. Hosting an <strong>impressive mix of world-renowned and uprising DJs</strong> featuring a mix of house, techno, and groovy electronic music',
      id: '3XFzRrUYlwY?t=195',
      videoUrl: 'https://www.youtube.com/embed/3XFzRrUYlwY?t=195',
    },
  },
  'rosa-negra-tulum': {
    name: 'Rosa Negra',
    caption: 'Latin American Cuisine & Live Shows',
    color: '#dd9e6d',
    secondaryColor: '#5b2f27',
    logo:
      'https://imgix.cosmicjs.com/2d020bb0-d4d7-11ee-9ce5-59949019255e-logo-rosa-negra-tulum.png',
    video: {
      title: 'Rosa Negra Tulum',
      youtube: true,
      content:
        'Where <b>Dinner Transforms</b> into a Latin expression with happenings, sparklers, and live music. <b>Join the Vibrant Fiesta!</b></p>',
      id: 'Op0GN4uKEec',
      videoUrl: 'https://www.youtube.com/embed/Op0GN4uKEec',
    },
  },
  'rosanegra-beach-club-tulum': {
    name: 'Rosanegra Beach Club',
    caption: 'Wild blue paradise',
    color: '#75abf2',
    secondaryColor: '#2b7de9',
    logo:
      'https://imgix.cosmicjs.com/c6e93110-d5a7-11ee-9ce5-59949019255e-logo-rosanegra-beach-club-tulum.png',
    video: {
      title: 'Rosanegra Beach Club in Tulum',
      youtube: true,
      content:
        '<p>Catching a special night event at <b>Rosa Negra Beach Club</b> will be rare. These events have a lit atmosphere, however, they only occur on special occasions</p>',
      id: 'gzrGlo9oA5E',
      videoUrl: 'https://www.youtube.com/embed/gzrGlo9oA5E',
    },
  },
  'gitano-beach-tulum': {
    name: 'Gitano Beach',
    logo:
      'https://imgix.cosmicjs.com/d72577a0-d4da-11ee-9ce5-59949019255e-logo-gitano-beach-tulum.png',
    secondaryColor: 'rgb(208 188 164)',
    caption: 'Path To Paradise',
    color: '#A0886A',
    video: {
      title: 'Gitano Beach',
      content: '<p>Disco caribbean <b>adventures</b> within a perfect beachfront environment. </p>',
      id: 'Gb4JkhHjqk8',
      youtube: 'true',
      videoUrl: 'https://www.youtube.com/embed/Gb4JkhHjqk8',
    },
  },
  'gitano-tulum': {
    name: 'Gitano Jungle',
    caption: 'Jungle Fever',
    logo:
      'https://imgix.cosmicjs.com/9dca4c20-d4d4-11ee-9ce5-59949019255e-logo-gitano-tulum.png',
    secondaryColor: 'rgb(201 181 201)',
    color: 'rgb(87 45 60)',
    video: {
      title: 'Gitano Tulum',
      caption: 'JUNGLE FEVER',
      id: 'qrAZXIMNdbw',
      youtube: 'true',
      videoUrl: 'https://www.youtube.com/embed/qrAZXIMNdbw',
    },
  },
  'taboo-tulum': {
    name: 'Taboo Tulum',
    caption: 'Beach Club Party & Live Shows',
    color: '#5f4f4b',
    secondaryColor: '#706053',
    logo:
      'https://imgix.cosmicjs.com/616c3fe0-d4d9-11ee-9ce5-59949019255e-logo-taboo-tulum.png',
    video: {
      title: 'TABOO',
      content:
        'Taboo Day and Night <br> There are always <a href="/article/taboo-tulum-day-events">party vibes at Taboo Tulum!</a>, At Taboo it doesnt matter whether it is daylight or nighttime, the  music and celebration are always on cue! ',
      id: 'c1RfZMYyFq0',
      youtube: 'true',
      videoUrl: 'https://www.youtube.com/embed/c1RfZMYyFq0',
    },
  },
  'tantra-tulum': {
    name: 'Tantra Tulum',
    caption: 'Bohemian restaurant & Beach Club',
    color: '#c8b9ac',
    secondaryColor: '#5f4f4b',
    logo:
      'https://imgix.cosmicjs.com/53ed4f20-d5a7-11ee-9ce5-59949019255e-logo-tantra-tulum.png',
    bgPalm: `https://imgix.cosmicjs.com/0e9bd970-f811-11ec-b2b1-473235369c53-image.png?q=&w=800&h=500&fit=clamp&h=160&h&duotone=f86522,black&duotone-alpha=100&auto=format`,
    video: {
      title: 'LUXURIUOS LIVE SHOWS',
      content:
        'Live Sax and violin performances, resident DJs, and a <strong>Luxury festive atmosphere</strong>, is what you can expect at Tantra Tulum.',
      id: 'NwDGVWFgwsc',
      youtube: 'true',
      videoUrl: 'https://www.youtube.com/embed/NwDGVWFgwsc',
    },
    extraImage: '',
  },
  'balabamba-tulum': {
    name: 'Balabamba Tulum',
    color: '#798fdd',
    secondaryColor: '#405bac',
    logo:
      'https://imgix.cosmicjs.com/bd0fae50-d4d8-11ee-9ce5-59949019255e-logo-balabamba-tulum.png',
    bgPalm: `https://imgix.cosmicjs.com/0e9bd970-f811-11ec-b2b1-473235369c53-image.png?q=&w=800&h=500&fit=clamp&h=160&h&duotone=f86522,black&duotone-alpha=100&auto=format`,
    video: {
      title: 'Balabamba Tulum',
      content:'',
      id: '5rzTDhLgPyw',
      youtube: 'true',
      videoUrl: 'https://www.youtube.com/watch?v=5rzTDhLgPyw',
    },
    extraImage: '',
  },
  'chambao-tulum': {
    name: 'Chambao Tulum',
    caption: 'Fashion Grillhouse',
    secondaryColor: '#1f1f1e',
    color: '#c68562',
    logo:
      'https://imgix.cosmicjs.com/f02b1430-195e-11ef-9eca-7d347081a9fb-logo-chambao-tulum.png',
    bgPalm: `https://imgix.cosmicjs.com/0e9bd970-f811-11ec-b2b1-473235369c53-image.png?q=&w=800&h=500&fit=clamp&h=160&h&duotone=f86522,black&duotone-alpha=100&auto=format`,
    video: {
      title: 'Chambao Tulum',
      content:'Fashion Grillhouse. Meets at Chambao Tulum! ✨ Experience the bohemian paradise',
      id: '9il-9ZR0c14',
      youtube: 'true',
      videoUrl: 'https://www.youtube.com/watch?v=9il-9ZR0c14',
    },
  },
  'mayan-monkey-tulum': {
    name: 'Mayan Monkey',
    caption: 'Stay, Share & Socialize',
    color: '#93995b',
  },
  'ahau-tulum': {
    name: 'Ahau Tulum',
    caption: 'Vibrant and authentic beachfront resort between the jungle and the sea.',
    secondaryColor: '#996f5b',
    color: '#d9d9d7',
    logo: 'https://imgix.cosmicjs.com/73d4b1c0-c71e-11ef-bee4-3bb1d3c55332-logo-ahau-instagram.png',
  },
  'h-moonlight-tulum': {
    name: 'H MOONLIGHT',
    logo:
      'https://imgix.cosmicjs.com/75e13ad0-cbca-11ec-b98f-db6f075d4374-logo-ilios-r.png',
    color: '#c11e50',
  },
  'ilios-restaurant-tulum': {
    name: 'ILIOS',
    caption: 'Where Taste Meets Passion',
    logo:
      'https://imgix.cosmicjs.com/a6a32060-d5a6-11ee-9ce5-59949019255e-logo-ilios-restaurant-tulum.png',
    color: '#b3a8a3',
    secondaryColor: '#513a1f',
    video: {
      title: 'ILIOS Tulum',
      content:'<p>Smash a plate and shout <strong>OPA!</strong></p><p>"Where taste meets passion</p>',
      id: 'Ku4LBQ_QBy4',
      youtube: 'true',
      videoUrl: ' https://www.youtube.com/watch?v=Ku4LBQ_QBy4',
    },

  },
  'karma-restaurant-tulum': {
    name: 'KARMA',
    caption: 'Restaurant & Bar',
    color: 'rgb(118 92 76)',
    logo:
      'https://imgix.cosmicjs.com/a56bd680-da54-11ee-b6bc-0f88b0862d1c-logo-karma-restaurant-tulum.png',
    secondaryColor: 'rgb(40 21 11)',
    video: {
      title: 'Karma Tulum',
      content:'<p>A nested jungle <strong>paradise</strong><br>Unique spaces invite you to experience unforgettable moments, whether enjoying a romantic candlelight dinner or a sunset dj session.</p>',
      id: 'xzs7d_3Ijyk',
      youtube: 'true',
      videoUrl: ' https://www.youtube.com/watch?v=xzs7d_3Ijyk',
    },

  },
  "funky-geisha-tulum": {
    name: 'Funky Geisha Tulum',
    caption: 'Asian Cuisine & Taiko Drum Shows',
    color: '#dd9e6d',
    secondaryColor: '#5b2f27',
    logo:
      'https://imgix.cosmicjs.com/e8632e10-1c9a-11ef-9eca-7d347081a9fb-logo-funky-geisha-tulum.png',
    video: {
      title: 'Funky Geisha',
      content:'<p><b>A culinary</b> tantric experience. </p>',
      id: 'g8o6GolbPr4',
      youtube: 'true',
      videoUrl: ' https://www.youtube.com/watch?v=g8o6GolbPr4',
    },
  },
  "mamazzita-tulum": {
    name: 'Mamazzita Tulum',
    caption: 'Mexican Inspired Cuisine | Fire Shows',
    color: 'rgb(189 38 43)',
    secondaryColor: '#ee4e46',
    logo:
      'https://imgix.cosmicjs.com/89d29a90-6c57-11ef-a492-5bdc7520fe60-Captura-de-pantalla-2024-09-06-075212.png',
    video: {
      title: 'Mamazzita',
      content:'<p>Discover The New Mexican Culinary Experience</p>',
      id: 'k9FSujLpK4Q',
      youtube: 'true',
      videoUrl: 'https://www.youtube.com/watch?v=k9FSujLpK4Q',
    },
  },
  "parole-tulum": {
    name: 'Parole Tulum',
    caption: 'Coastal Italian Cusine | Violinist',
    color: '#ccb985',
    secondaryColor: '#A08A5D',
    video: {
      title: 'PAROLE TULUM',
      content: '<hr><p>Experience a <strong>unique dining experience</strong> at Parole Tulum. Enjoy a <b>violin concert</b> 🎻 while savoring delicious Italian cuisine 🍝.</p>',
      id: 'qTlfT6c-PSU',
      youtube: 'true',
      videoUrl: 'https://www.youtube.com/watch?v=qTlfT6c-PSU',
    },
    logo:
      'https://imgix.cosmicjs.com/7fd06c30-6c6f-11ef-b5ae-a594bb4a8e67-Parole-Logo.png',
  },
  "tora-tulum": {
    name: 'Tora Tulum',
    caption: 'Contemporary Japanese Cuisine | Izakaya Style',
    color: '#b97731',
    secondaryColor: '#E3C39F',
    logo:
      'https://imgix.cosmicjs.com/89d1b030-6c57-11ef-a492-5bdc7520fe60-Captura-de-pantalla-2024-09-06-075338.png',
    video: {
      title: 'TORA TULUM',
      content: '<p><hr>Tora Tulum offers a 🍣 <strong>unique</strong> and <strong>🥢 innovative</strong> approach to Japanese cuisine. Combining <strong>traditional techniques</strong> with <strong>modern culinary artistry</strong>, 🇯🇵  a <strong>sophisticated dining experience</strong> that showcases the finest <strong>gourmet ingredients</strong>.</p>',
      id: 'r3uJwg2wRg4',
      youtube: 'true',
      videoUrl: 'https://www.youtube.com/watch?v=r3uJwg2wRg4',
    },
  },
  "bestiario-tulum": {
    name: 'Bestiario Tulum',
    caption: 'Cyber Cosmic Ancient Club',
    color: '#125754',
    secondaryColor: '#A08A5D',
    logo:
      'https://imgix.cosmicjs.com/bb0c3d60-6c5b-11ef-b5ae-a594bb4a8e67-imagen_2024-09-06_112430338.png',
    video: {
      title: 'BESTIARIO TULUM',
      content: '<hr><p>Experience the energy and excitement of Valderrama\'s performance, captured live in <strong>Bestiario Tulum by <strong>Ephimera.</strong></p>',
      id: 'VKV4h6pupwI',
      youtube: 'true',
      videoUrl: 'https://www.youtube.com/watch?v=VKV4h6pupwI',
    },
  },
  "meze-tulum": {
    name: 'Meze Tulum',
    color: '#b0a9a6',
  },
  "buuts-ha-tulum": {
    logo: 'https://imgix.cosmicjs.com/f491b020-d5a6-11ee-9ce5-59949019255e-logo-buuts-ha-tulum.png',
    name: 'Buuts Ha',
    color: 'rgb(23 97 115)',
    secondaryColor: 'rgb(70 72 71)',
  },
  "kanan-beach-club-tulum": {
    name: 'Kanan Beach Club',
    caption: 'Restaurant & Bar',
    secondaryColor: '#A08A5D',
    color: '#b0a9a6',
    video: {
      title: 'RESET SUNDAYS',
      content: '<hr><p>Boutique hotel, adults only scene,\n' +
        'DJs spinning, a culinary dream.\n' +
        'Relax in nests, with ocean view,\n' +
        'A paradise for you. </p>',
      id: 'yUPSGC68ad8',
      youtube: 'true',
      videoUrl: 'https://www.youtube.com/watch?v=yUPSGC68ad8',
    },
    logo:
      'https://imgix.cosmicjs.com/fe5e9890-d4dc-11ee-9ce5-59949019255e-logo-kanan-beach-club-tulum.png',
  },
  "bak-tulum": {
    name: 'BAK STAKE HOUSE TULUM',
    caption: 'Beach, Beats & Flavors',
    secondaryColor: '#69381d',
    color: '#b0a9a6',
    logo:
      'https://imgix.cosmicjs.com/dedf3560-ceb4-11ef-8a63-eb57d6c77a36-Bak-logo-ig.png',
  } ,
  "vesica-tulum": {
    name: 'VESICA TULUM',
    caption: 'Jungle Cenote Paradise',
    secondaryColor: '#5e6255',
    color: '#a6a79b',
    video: {
      title: 'PERSENTAION: HUMANS AT VESICA',
      content: '<hr><p>NOMAD HUMANS & IRENA:  Latin House from the Hearth</p>',
      id: 'T4Fyv6DpVW0',
      youtube: 'true',
      videoUrl: 'https://www.youtube.com/watch?v=T4Fyv6DpVW0',
    },
    logo:
      'https://imgix.cosmicjs.com/2c071ba0-c663-11ef-bee4-3bb1d3c55332-Vesica-Logo.jpg',
  },
  "kiri-tulum": {
    name: 'KIRI TULUM',
    caption: 'Let\'s K-Dance',
    secondaryColor: '#8c898b',
    color: '#a6a79b',
    logo:
      'https://imgix.cosmicjs.com/7a24b150-c9ea-11ef-bee4-3bb1d3c55332-Kiri-logo.jpg',
  },
  "it-tulum": {
    name: 'IT TULUM',
    caption: 'Beach, Beats & Flavors',
    secondaryColor: '#A08A5D',
    color: '#b0a9a6',
    logo:
      'https://imgix.cosmicjs.com/3b34ccf0-bcc5-11ef-bee4-3bb1d3c55332-It-tulum-logo.png',
  }
});
